import { z } from 'zod';

/**
 * Optional text search param. The router JSON-parses query values, so `?q=4471` or
 * `?import=1` arrive as numbers; they are read back as the text the user typed.
 */
export const zSearchText = () => z.preprocess((v) => (typeof v === 'number' || typeof v === 'boolean' ? String(v) : v), z.string().optional());
